<template>
    <div>
        <Main title="POI Brands" subtitle="Locations Map">
            <template v-slot:table>
                <div class="row">
                    <div class="col-md-4">
                        <ul class="list-unstyled">
                            <li>Brand: <strong>{{ brandName }} </strong></li>
                            <li>Total Locations: <strong>{{ locations.length }}</strong></li>
                        </ul>
                    </div>
                    <div class="col-md-6 offset-md-2">
                        <ul class="mr-5 list-unstyled d-inline-block align-top">
                            <li class="mb-1">
                                <img class="ml-n1" src="https://maps.google.com/mapfiles/ms/icons/orange-dot.png" alt="">
                                <span class="align-top">- GPS Point</span>
                            </li>
                            <li class="mb-1">
                                <div class="d-inline-block rounded-circle" style="width: 25px; height: 25px; border: 2px solid rgba(0, 0, 0, 0.3);"></div>
                                <span class="align-top">- Max Trade Area</span>
                            </li>
                        </ul>
                        <ul class="mr-2 list-unstyled d-inline-block align-top">
                            <li class="mb-1">
                                <img class="align-top" src="https://maps.google.com/mapfiles/ms/icons/blue-dot.png" alt="">
                                <span class="align-top">- Polygon Object & GPS Centroid is aligned to Polygon center</span>
                            </li>
                            <li class="mb-1">
                                <img class="align-top" src="https://maps.google.com/mapfiles/ms/icons/red-dot.png" alt="">
                                <span class="align-top">- Polygon Object & GPS centroid is not located in the center of the polygon</span>
                            </li>
                        </ul>
                    </div>
                </div><!--row-->

                <div class="row">
                    <div class="col-12">
                        <GmapMap
                            :center="center"
                            :zoom="map_zoom"
                            style="height: 800px; margin: auto;"
                            @rightclick="drawPolygon($event)"
                        >
                            <GmapPolyline
                                :center="polygonCenter"
                                :path="drawingPolygonPoints"
                            ></GmapPolyline>
                            <div v-for="(location, index) in locations" :key="index">
                                <GmapCircle
                                    v-if="drawingPolygonLocation === null && (editingLocation === location.id || editingLocation === null)"
                                    :center="{lat: parseFloat(location.lat), lng: parseFloat(location.lon)}"
                                    :radius="location.maxTradeArea * 1609.344"
                                    :options="maxTradeAreaOptions"
                                    :editable="editingLocation === location.id"
                                    @radius_changed="maxTradeAreaChanged($event, location.id)"
                                    @center_changed="centerChanged($event, location.id)"
                                ></GmapCircle>
                                <GmapPolygon
                                    v-if="((editingLocation === null && drawingPolygonLocation === null) || (editingLocation === location.id || drawingPolygonLocation === location.id)) && location.polygon"
                                    :paths="getLocationCoordinates(location.polygon.coordinates[0], {lat: parseFloat(location.lat), lng: parseFloat(location.lon)}, index)"
                                    :editable="editingLocation === location.id"
                                    :options="{
                                        strokeColor: location.polygonColor,
                                        strokeOpacity: 0.9,
                                        strokeWeight: 2,
                                        fillColor: location.polygonColor,
                                        fillOpacity: 0.2,
                                    }"
                                    @paths_changed="polygonPathsChanged($event)"
                                >
                                </GmapPolygon>

                                <GmapMarker
                                    v-if="(editingLocation === null && drawingPolygonLocation === null) || (editingLocation === location.id || drawingPolygonLocation === location.id)"
                                    :position="{lat: parseFloat(location.lat), lng: parseFloat(location.lon)}"
                                    :icon="location.marker || icon"
                                    @click="openMarker(location.id)"
                                >
                                    <GmapInfoWindow
                                        @closeclick="openMarker(null)"
                                        :opened="openedMarkerID === location.id"
                                        :closeclick="true"
                                        :options=" {
                                            minWidth: 400
                                        }"
                                    >
                                        <div>
                                            <h3>{{ location.name || "" }}</h3>
                                            <span class="info-area"><strong>ID: </strong> {{ location.id || "" }}</span> <br />
                                            <span class="info-area"><strong>Address: </strong> {{ location.address1 || "" + ' ' + (location.address2 ? location.address2 : "") }}</span> <br />
                                            <span class="info-area"><strong>City: </strong> {{ location.city || "" }} </span> <br />
                                            <span class="info-area"><strong>State: </strong> {{ location.state || "" }} </span> <br />
                                            <span class="info-area"><strong>Zip Code: </strong> {{ location.zip_code || "" }} </span> <br />
                                            <span class="info-area"><strong>Lat & Lon: </strong> {{ location.lat || "" }}, {{ location.lon || "" }} </span> <br />
                                            <span class="info-area"><strong>MaxTradeArea: </strong> {{ location.maxTradeArea }} miles ({{ (location.maxTradeArea * 1609.344).toFixed(3) }} meters) </span> <br />
                                            <span v-if="location.polygonCenter">
                                                <span class="info-area"><strong>Polygon Center: </strong> {{ location.polygonCenter.lat }}, {{ location.polygonCenter.lng }} </span> <br />
                                            </span>
                                            <div class="btn-group mt-3 d-flex justify-content-between" role="group" aria-label="User Actions">
                                                <button v-if="(location.id !== editingLocation) && (location.id !== drawingPolygonLocation) && $store.getters.getUserPermissions.includes('frontend-admin-pois-taxonomies-map-edit')" @click="editLocation(location.id)" style="max-width: 50%;" data-toggle="tooltip" data-placement="top" title="Edit Location" class="btn btn-info">
                                                    <i class="fas fa-edit"></i>
                                                    <span class="ml-1">Edit</span>
                                                </button>
                                                <button v-if="((location.id === editingLocation) || (location.id === drawingPolygonLocation)) && $store.getters.getUserPermissions.includes('frontend-admin-pois-taxonomies-map-edit')" @click="cancelUpdating" style="max-width: 50%;" data-toggle="tooltip" data-placement="top" title="Cancel Location Update" class="btn btn-danger">
                                                    <i class="fas fa-times"></i>
                                                    <span class="ml-1">Cancel</span>
                                                </button>
                                                <button v-if="((location.id === editingLocation) || (location.id === drawingPolygonLocation)) && $store.getters.getUserPermissions.includes('frontend-admin-pois-taxonomies-map-edit')" @click="saveLocation()" data-toggle="tooltip" data-placement="top" title="Save Location" class="btn btn-success">
                                                    <i class="fas fa-check"></i>
                                                    <span class="ml-1">Save</span>
                                                </button>
                                                <button v-if="((location.id !== editingLocation) && (location.id !== drawingPolygonLocation) && !location.polygon) && $store.getters.getUserPermissions.includes('frontend-admin-pois-taxonomies-map-edit')" @click="startDrawingPolygon(location)" style="max-width: 50%;" data-toggle="tooltip" data-placement="top" title="Draw Polygon" class="btn btn-dark">
                                                    <i class="fas fa-draw-polygon"></i>
                                                    <span class="ml-1">Draw Polygon</span>
                                                </button>
                                                <button v-if="((location.id !== editingLocation) && (location.id !== drawingPolygonLocation))" @click="showDeleteModal(location)" style="max-width: 50%;" data-toggle="tooltip" data-placement="top" title="Edit Location" class="btn btn-danger">
                                                    <i class="fas fa-times"></i>
                                                    <span class="ml-1">Delete</span>
                                                </button>
                                                <a v-if="((location.id !== editingLocation) && (location.id !== drawingPolygonLocation))" target="_blank" :href="`https://www.google.com/maps/place/${location.address1},${location.city},${location.state}+${location.zip_code}+${location.country}/@${location.lat},${location.lon},17z`" data-toggle="tooltip" data-placement="top" title="View Location in Google Maps" class="btn btn-primary" >
                                                    <i class="fas fa-map-marked"></i>
                                                    <span class="ml-1">View Location in Google Maps</span>
                                                </a>
                                            </div>
                                            <div class="btn-group mt-2 d-flex justify-content-between" v-if="(editingLocation === null && drawingPolygonLocation === null)">
                                                <button @click="previousLocation(index)" style="max-width: 50%;" data-toggle="tooltip" data-placement="top" title="Previous" class="btn btn-light mr-1">
                                                    <i class="fas fa-angle-double-left"></i>
                                                </button>
                                                <button @click="nextLocation(index)" style="max-width: 50%;" data-toggle="tooltip" data-placement="top" title="Next" class="btn btn-light ml-1">
                                                    <i class="fas fa-angle-double-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </GmapInfoWindow>
                                </GmapMarker>
                            </div>
                        </GmapMap>
                    </div>
                </div>
            </template>
        </Main>
        <DeleteModal v-if="deleteModalDialog"></DeleteModal>
    </div>
</template>

<script>
import Main from '../../../components/Main'
import mixins from "../../../mixin";
import TableLoading from "../../../components/general/TableLoading";
import api from "../../../api/my-data/poi/taxonomies"
import DeleteModal from "../../../components/general/DeleteModal";

export default {
    name: "TaxonomiesMap",
    mixins: [mixins],
    data: () => ({
        map_zoom: 14,
        editable: true,
        draggable: true,
        brand: null,
        brandName: "None",
        locations: [],
        openedMarkerID: null,
        icon: 'https://maps.google.com/mapfiles/ms/icons/orange-dot.png',
        center: {
            lat: 0,
            lng: 0
        },
        selectedCenterId: null,
        maxTradeAreaOptions: {
            strokeColor: "#000000",
            strokeOpacity: 0.3,
            strokeWeight: 2,
            fillOpacity: 0,
        },
        editingLocation: null,
        editingLocationData: {
            polygon: null,
            maxTradeArea: null,
            lat: null,
            lng: null
        },
        drawingPolygonPoints: [],
        drawingPolygonLocation: null,
        polygonCenter: {
            lat: null,
            lng: null
        },
        deletingLocation: [],
        deleteModalDialog: false
    }),
    components: {
        DeleteModal,
        TableLoading,
        Main
    },
    methods: {
        async fetchData(editing = false) {
            await api.getAllBrandLocations({
                brand: this.brand
            })
            .then(res => {
                if (res.data.locations.length) {
                    this.locations = res.data.locations
                    this.brandName = res.data.brand_name

                    if (!editing) {
                        this.center.lat = parseFloat(this.locations[0].lat || 0)
                        this.center.lng = parseFloat(this.locations[0].lon || 0)
                        this.selectedCenterId = 0
                    }
                } else {
                    this.$toast.open({
                        message: "No locations found",
                        type: "error",
                    })
                }

            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.message,
                    type: "error",
                })
            })
        },
        async updateLocation() {
            await api.updateLocation({
                id: this.editingLocation,
                polygon: this.editingLocationData.polygon,
                lat: this.editingLocationData.lat,
                lng: this.editingLocationData.lng,
                maxTradeArea: this.editingLocationData.maxTradeArea
            })
            .then(res => {
                this.$toast.open({
                    message: res.data.message,
                    type: "success",
                })
                this.cancelUpdating()
                this.fetchData(true)
            })
            .catch(e => {
                this.cancelUpdating()
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
            })
        },
        async deleteItem() {
            await api.deleteLocation({
                id: this.deletingLocation.id,
            })
                .then(res => {
                    this.deleteModalDialog = false
                    this.deletingLocation = []
                    this.fetchData()
                    this.$toast.open({
                        message: res.data.message,
                        type: "success",
                    })
                })
                .catch(e => {
                    this.$toast.open({
                        message: e.response.data.message,
                        type: "error",
                    })
                    this.deleteModalDialog = false
                    this.deletingLocation = []
                })
        },
        getLocationCoordinates(coordinates, center, index) {
            const polygonLngLat = []
            const polygonLngLatArray = []
            this.locations[index].marker = "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";
            this.locations[index].polygonColor = 'rgb(0, 71, 171)'

            coordinates.forEach(function (item) {
                polygonLngLat.push({lat: item[1], lng: item[0]})
                polygonLngLatArray.push([item[0], item[1]])
            })

            const polygonCenter = this.getPolygonCenter(polygonLngLat)
            this.locations[index].polygonCenter = polygonCenter

            if (!this.isMarkerInsidePolygon([center.lng, center.lat], polygonCenter)) {
                this.locations[index].polygonColor = 'rgb(196, 30, 58)';
                this.locations[index].marker = "https://maps.google.com/mapfiles/ms/icons/red-dot.png";
            }

            return polygonLngLat
        },
        getPolygonCenter(coordinates) {
            let first = coordinates[0], last = coordinates[coordinates.length-1];
            if (first.lng != last.lng || first.lat != last.lat) coordinates.push(first);
            let twicearea=0,
                x=0, y=0,
                nPts = coordinates.length,
                p1, p2, f;

            for ( let i=0, j=nPts-1 ; i<nPts ; j=i++ ) {
                p1 = coordinates[i]; p2 = coordinates[j];
                f = p1.lng*p2.lat - p2.lng*p1.lat;
                twicearea += f;
                x += ( p1.lng + p2.lng ) * f;
                y += ( p1.lat + p2.lat ) * f;
            }
            f = twicearea * 3;

            return { lng: (x/f).toFixed(8), lat: (y/f).toFixed(8) };
        },
        isMarkerInsidePolygon(markerPosition, polygonCenter, radius = 1) {

            const km = radius/1000;
            const kx = Math.cos(Math.PI * polygonCenter.lat / 180) * 111;
            const dx = Math.abs(polygonCenter.lng - markerPosition.lng) * kx;
            const dy = Math.abs(polygonCenter.lat - markerPosition.lat) * 111;

            return Math.sqrt(dx * dx + dy * dy) <= km;
        },
        openMarker(id) {
            this.openedMarkerID = id
        },
        editLocation(id) {
            this.cancelUpdating()

            this.editingLocation = id
        },
        saveLocation() {
            if (this.drawingPolygonLocation) {
                this.editingLocation = this.drawingPolygonLocation
                this.editingLocationData.polygon = this.getPolygonFromPoints()
            }

            this.updateLocation()
        },
        cancelUpdating() {
            this.editingLocation = null
            this.editingLocationData.maxTradeArea = null
            this.editingLocationData.polygon = null
            this.editingLocationData.lat = null
            this.editingLocationData.lng = null
            this.drawingPolygonLocation = null
            this.drawingPolygonPoints = []
        },
        polygonPathsChanged(mvcArray) {
            let polygon = 'POLYGON((';
            for (let i=0; i<mvcArray.getLength(); i++) {
                for (let j=0; j<mvcArray.getAt(i).getLength(); j++) {
                    let point = mvcArray.getAt(i).getAt(j);

                    if (j !== 0) {
                        polygon += ', '
                    }
                    polygon += `${point.lng()} ${point.lat()}`
                }
            }
            polygon += '))'
            this.editingLocationData.polygon = polygon;
        },
        getPolygonFromPoints() {
            let polygon = 'POLYGON((';

            for (let i=0; i<this.drawingPolygonPoints.length; i++) {
                let point = this.drawingPolygonPoints[i]
                if (i !== 0) {
                    polygon += ', '
                }

                polygon += `${point.lng} ${point.lat}`
            }
            polygon += this.closePolygonLoop()

            polygon += '))'

            return polygon
        },
        closePolygonLoop() {
            let point = this.drawingPolygonPoints[0]

            return `, ${point.lng} ${point.lat}`
        },
        maxTradeAreaChanged(radius, id) {
            if (id === this.editingLocation) {
                this.editingLocationData.maxTradeArea = radius.toFixed(3)
            }
        },
        centerChanged(center, id) {
            if (id === this.editingLocation) {
                this.editingLocationData.lat = center.lat()
                this.editingLocationData.lng = center.lng()
            }
        },
        previousLocation(index) {
            let locationIndex = this.locations.length - 1

            if (this.locations[index - 1]) {
                locationIndex = index - 1
            }

            this.center.lat = parseFloat(this.locations[locationIndex].lat || 0)
            this.center.lng = parseFloat(this.locations[locationIndex].lon || 0)
            this.openedMarkerID = this.locations[locationIndex].id
        },
        nextLocation(index) {
            let locationIndex = 0

            if (this.locations[index + 1]) {
                locationIndex = index + 1
            }

            this.center.lat = parseFloat(this.locations[locationIndex].lat || 0)
            this.center.lng = parseFloat(this.locations[locationIndex].lon || 0)
            this.openedMarkerID = this.locations[locationIndex].id
        },
        showDeleteModal(location) {
            this.deletingLocation = location
            this.deleteModalDialog = true
        },
        startDrawingPolygon(location) {
            this.cancelUpdating()

            this.$toast.open({
                message: 'Draw a polygon by clicking on the map with your right mouse button.',
                type: "info",
            })

            this.drawingPolygonLocation = location.id
        },
        drawPolygon(event) {
            let point = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
            }

            this.drawingPolygonPoints.push(point)

            this.$toast.open({
                message: `Polygon Point added: Lat: ${point.lat}, Lng: ${point.lng}.`,
                type: "info",
            })
        }
    },
    computed: {

    },
    created() {
        let brandId = window.location.pathname.split("/")[4]
        if (brandId) {
            this.brand = brandId
        }

        this.fetchData()
    },
    watch: {

    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
    .info-area {
        font-size: 1.3em !important;
        line-height: 1.3em !important;
    }
</style>